module.exports = __webpack_public_path__ + "images/help_v2/avatars/passluo-ad962adbe3abb79dba6cfc04d06d4d81.png";